// extracted by mini-css-extract-plugin
export default {"container":"AddModel_container__Xxi34","progressContainer":"AddModel_progressContainer__FK8v8","addManufacturer":"AddModel_addManufacturer__v5oFz"};